module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-34.b62d66d5.png";